import ThemedComponent from '../../hoc/ThemedComponent';
import NotificationsPage from './NotificationsPage';
import { default as NotificationsPage3 } from '../../themes/3/pages/notifications/NotificationsPage';
import { default as NotificationsPage4 } from '../../themes/4/pages/notifications/NotificationsPage';

const ThemedNotificationsPages = {
    default: NotificationsPage,
    // 3: NotificationsPage3,
    // 4: NotificationsPage4,
};

export const ThemedNotificationsPage = ThemedComponent(ThemedNotificationsPages);